import { useSnackbarContext } from 'Context/SnackbarContext';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FDConfirmationDialog } from '@facet-wealth/design';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';

export default function SelectionConfirmationDialog({ onSelectScenario, confirmationDialogResource, setConfirmationDialogResource }) {
  const [confirming, setConfirming] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();

  const handleOnConfirm = () => {
    setConfirming(true);
    try {
      confirmationDialogResource.withRelationship(fr.relationships.confirm.name,
        async (rel) => {
          setConfirmationDialogResource(null);
          await onSelectScenario(rel);
        },
        () => setConfirmationDialogResource(null));
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to confirm, please try again.');
      }
    } finally {
      setConfirming(false);
    }
  };


  return (
    confirmationDialogResource ? (
      <FDConfirmationDialog
        open
        onConfirm={() => handleOnConfirm()}
        onClose={() => setConfirmationDialogResource(null)}
        title={confirmationDialogResource.attr('title')}
        message={confirmationDialogResource.attr('subTitle')}
        confirmLabel={confirmationDialogResource.relationship(fr.relationships.confirm.name)?.meta('prompt') || 'Confirm'}
        loading={confirming}
        {...dataAttrs('scenario-selection-confirmation-dialog')}
      />) : null
  );
}

SelectionConfirmationDialog.defaultProps = {
};

SelectionConfirmationDialog.propTypes = {
  onSelectScenario: PropTypes.func.isRequired,
  confirmationDialogResource: PropTypes.object.isRequired,
  setConfirmationDialogResource: PropTypes.func.isRequired,
};
